import React, { Component } from 'react'
import { connect } from 'react-redux'
import { currentUserStart, logoutStart } from '../redux/modules/user'
import data from '../data/appData'
import Footer from '../components/common/Footer'
import RestaurantLogin from '../components/common/RestuarantLogin'
import Header from '../components/common/Header'
import { SimpleSpinner } from '../components/common/SimpleSpinner'
import { loadProfileStart } from '../redux/modules/profile'
import { selectUserLocationId } from '../redux/modules/selectors'

export const HeaderComponent = ({
  currentUser,
  isAuthenticated,
  locationId,
  isCurrentUserLoading,
  profile,
  match
}) => {
  if (currentUser) {
    return (
      <Header
        isAuthenticated={isAuthenticated}
        locationId={locationId}
        currentUser={currentUser}
        isCurrentUserLoading={isCurrentUserLoading}
        menuItems={
          profile && profile.status !== 'CONFIRMED' ? null : data.headerMenu
        }
        logout={logoutStart}
        classNames={{ 'header-large': true }}
        match={match}
      />
    )
  } else {
    return (
      <Header
        classNames={{ 'header-large': true }}
        showLinks={
          typeof document !== 'undefined' &&
          window.location.pathname === '/login'
        }
        match={match}
      />
    )
  }
}

export class PublicLayout extends Component {
  componentDidMount() {
    this.props.currentUserStart(true, true)
    if (this.props.currentUser) {
      this.props.loadProfileStart()
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.currentUser && this.props.currentUser) {
      this.props.loadProfileStart()
    }
  }

  render() {
    const {
      children,
      isAuthenticated,
      currentUser,
      isCurrentUserLoading,
      locationId,
      profile,
      match
    } = this.props
    return (
      <div className="main">
        {isCurrentUserLoading ? (
          <SimpleSpinner />
        ) : (
          <HeaderComponent
            {...{
              currentUser,
              isCurrentUserLoading,
              isAuthenticated,
              locationId,
              profile,
              match
            }}
          />
        )}
        <article id="content" className="content">
          {children}
        </article>
        <RestaurantLogin />
        <Footer showLogo="true" isAuthenticated={isAuthenticated} />
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { isAuthenticated, currentUser, isCurrentUserLoading } = state.user
  const locationId = selectUserLocationId(state)
  const { profile } = state.profile

  return {
    isAuthenticated,
    currentUser,
    isCurrentUserLoading,
    locationId,
    profile
  }
}

const mapDispatchToProps = {
  logoutStart,
  currentUserStart,
  loadProfileStart
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublicLayout)
